export default "__VITE_ASSET__Dly$7$xX__"